var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

import _ from 'underscore';
import BaseCtrl from 'edge/platform/base/BaseCtrl';
import landingpagecriteria from 'text!../config/landingpagecriteria.json';
import checkSegmentationOption from 'edge/platform/segmentation/CheckSegmentationOption';

var fn = function fn($scope, $state, $stateParams, $q, brandingData, CampaignDataService, queryParamsData, abExperimentService, appConfig) {
    var ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        var matchCriteria = JSON.parse(landingpagecriteria);
        var prioritisedMatchCriteria = [matchCriteria.branding, matchCriteria.queryParams, matchCriteria.campaign, matchCriteria.abExperiment];
        var defaultLandingPage = appConfig.home;
        $q.all([$q.resolve(brandingData), $q.resolve(queryParamsData), $q.resolve(CampaignDataService)
        // abExperimentService.getExperimentValue('experimentA') //we don't consider ab testing for landing page segmentation
        ]).then(function (values) {
            var landingPage = void 0;
            values.find(function (variantValue, idx) {
                var segmentationCriteria = prioritisedMatchCriteria[idx];
                return _.pairs(segmentationCriteria).find(function (_ref) {
                    var _ref2 = _slicedToArray(_ref, 2),
                        lpName = _ref2[0],
                        criteria = _ref2[1];

                    var foundMatchingOption = checkSegmentationOption(criteria, variantValue);
                    landingPage = foundMatchingOption ? lpName : undefined;
                    return landingPage;
                });
            });
            landingPage = landingPage || defaultLandingPage;
            $state.go(landingPage, $stateParams.params);
        }, function () {
            $state.go(defaultLandingPage, $stateParams.params);
        });
    };

    return ctrl.create($scope);
};

fn.$inject = ['$scope', '$state', '$stateParams', '$q', 'brandingData', 'CampaignDataService', 'queryParamsData', 'gwAbExperimentService', 'state_plugin_config'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/segmentation/demolandingpage/controllers/LoadingLandingPageCtrl.js
// module id = 1069
// module chunks = 0